import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import ClassRoll from '../../components/class-roll/index';
import PortalCommunication from '../../portal-comms';
import { createClassRows, isListDifferent } from '../../helpers/grid-util';
import { filterClassroomByIds, nonEmptyClassroom, displayNewCourses } from '../../helpers/utils';
import { getCourseCountries } from '../school-roll/actions';
import { getProductTeachers } from '../teacher-roll/actions';
import classEnum from './constants';
import { showToast } from '../../components/toast/actions';
import messages from './messages';

import {
    printStudentsSignInCard,
    sortClassList,
    retrieveSelectedClasses,
    downloadClassRoll,
    openAddClassModal,
    closeAddClassModal,
    getProductCourses,
    getProductClassrooms,
    getSchoolCourses,
    addClass,
    closeAddClassValidationModal,
    clearFilterValue,
    changeFilterValue,
    updateSearchTerm,
    deleteClassrooms,
    openDeleteClassroomsConfirmation,
    closeDeleteClassroomsConfirmation,
    openDeleteClassroomsSuccess,
    closeDeleteClassroomsSuccess,
    getStudentByClassroomIdRequest,
    showHideSignInCardModalRequest,
    getUPFCourses,
    getNewCourses,
    clearProductCourses,
    clearUPFCourses
} from './actions';

class ClassRollContainer extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        selectedProduct: PropTypes.object,
        isClassroomDataLoaded: PropTypes.bool,
        isClassRollDownloaded: PropTypes.bool,
        classrooms: PropTypes.arrayOf(PropTypes.object),
        openAddClassModal: PropTypes.func,
        closeAddClassModal: PropTypes.func,
        showAddClassModal: PropTypes.bool,
        showAddClassConfirmationModal: PropTypes.bool,
        showAddClassValidationModal: PropTypes.bool,
        addClassValidationMessage: PropTypes.string,
        yearGroups: PropTypes.arrayOf(PropTypes.object),
        getCourseCountries: PropTypes.func,
        productCountries: PropTypes.arrayOf(PropTypes.object),
        productTeachers: PropTypes.arrayOf(PropTypes.object),
        productCourses: PropTypes.arrayOf(PropTypes.object),
        getProductCourses: PropTypes.func,
        getProductTeachers: PropTypes.func,
        getProductClassrooms: PropTypes.func,
        isTeacherDataLoaded: PropTypes.bool,
        isCountriesLoaded: PropTypes.bool,
        classModel: PropTypes.object,
        selectedClasses: PropTypes.arrayOf(PropTypes.number),
        filteredClasses: PropTypes.arrayOf(PropTypes.object),
        printStudentsSignInCard: PropTypes.func,
        isStudentsSignInCardDownloaded: PropTypes.bool,
        isProductCoursesLoaded: PropTypes.bool,
        isSaveInProgress: PropTypes.bool,
        downloadClassRoll: PropTypes.func,
        sortClassList: PropTypes.func,
        retrieveSelectedClasses: PropTypes.func,
        dataFilterOption: PropTypes.object,
        addClass: PropTypes.func,
        closeAddClassValidationModal: PropTypes.func,
        refreshList: PropTypes.bool,
        clearFilterValue: PropTypes.func,
        changeFilterValue: PropTypes.func,
        updateSearchTerm: PropTypes.func,
        getStudentByClassroomIdRequest: PropTypes.func,
        deleteClassrooms: PropTypes.func,
        openDeleteClassroomsConfirmation: PropTypes.func,
        closeDeleteClassroomsConfirmation: PropTypes.func,
        openDeleteClassroomsSuccess: PropTypes.func,
        closeDeleteClassroomsSuccess: PropTypes.func,
        getProductStudents: PropTypes.func,
        showToast: PropTypes.func,
        showHideSignInCardModalRequest: PropTypes.func,
        showHideSignInCardModal: PropTypes.bool,
        getUPFCourses: PropTypes.func,
        getNewCourses: PropTypes.func,
        clearProductCourses: PropTypes.func,
        classAdded: PropTypes.string,
        deletedClassesCount: PropTypes.number
    };

    static contextTypes = {
        router: PropTypes.object
    }

    constructor(props) {
        super(props);
        this.handleGridSort = this.handleGridSort.bind(this);
        this.rows = props.isClassroomDataLoaded ? createClassRows(props.filteredClasses, props.intl) : [];
        this.state = {
            rows: this.rows,
            dataFilterOption: this.props.dataFilterOption
        };
        this.handleOnCloseModal = this.handleOnCloseModal.bind(this);
        this.handleListOnChange = this.handleListOnChange.bind(this);
        this.handleOnAssignStudent = this.handleOnAssignStudent.bind(this);
        this.displayNewCourses = displayNewCourses();
    }
    componentDidMount() {
        if (!this.props.isClassroomDataLoaded) {
            this.props.getProductClassrooms(this.props.selectedProduct.id);
        }

        if (!this.props.isTeacherDataLoaded) {
            this.props.getProductTeachers(this.props.selectedProduct.id);
        }

        if (!this.props.isCountriesLoaded) {
            this.props.getCourseCountries(this.props.selectedProduct.id);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isClassroomDataLoaded ||
            isListDifferent(nextProps.filteredClasses, this.props.filteredClasses, 'classroomId')) {
            this.rows = createClassRows(nextProps.filteredClasses, nextProps.intl);
            this.setState({ rows: this.rows });
        }

        if (nextProps.refreshList !== this.props.refreshList) {
            if (nextProps.refreshList) {
                this.refreshList();
            }

            if (nextProps.deletedClassesCount) {
                this.props.showToast(`${nextProps.deletedClassesCount} ${this.props.intl.formatMessage(messages.deleteClassConfirmation)}`, 'success');
            } else {
                this.props.showToast(`${nextProps.classAdded} ${this.props.intl.formatMessage(messages.addClassConfirmation)}`, 'success');
            }
        }

        if (nextProps.isStudentsSignInCardDownloaded !== this.props.isStudentsSignInCardDownloaded) {
            setTimeout(this.props.showHideSignInCardModalRequest(false), 1000);
        }

        this.setState({ dataFilterOption: this.props.dataFilterOption });
    }

    handleGridSort(sortColumn) {
        this.props.sortClassList(sortColumn);
    }

    handleRowSelect = (rows) => {
        this.props.retrieveSelectedClasses(rows);
    };

    handleFilterOnClear = () => {
        this.props.clearFilterValue();
    };

    handleFilterOnChange = (collectionName, key) => {
        this.props.changeFilterValue(collectionName, key);
    };

    handleOnSearch = (searchTerm) => {
        this.props.updateSearchTerm(searchTerm);
    };

    handleOnDownloadClassRoll = () => {
        this.props.downloadClassRoll(this.props.filteredClasses, false);
    };

    handleOnQuickUpload = () => {
        this.context.router.history.push('quickUpload');
    };

    handleOnCloseModal = () => {
        this.props.closeAddClassModal();
    };

    handleListOnChange = (classModel, field) => {
        if ((classModel.yearGroup !== '-1' && classModel.countryId !== '-1') && (field === 'yearGroup' || field === 'countryId')) {
            classModel.courseId = '-1';
            this.props.getProductCourses(classModel.countryId, this.props.selectedProduct.id, classModel.yearGroup);
        }
    };

    handleOnDownloadStudentsSignInCards = (format) => {
        const studentSignInCardsData = { ClassroomIds: this.props.selectedClasses, SignInCardPageSizeType: format };
        this.props.printStudentsSignInCard(this.props.selectedProduct.id, studentSignInCardsData);
    };

    refreshList = () => {
        this.props.getProductClassrooms(this.props.selectedProduct.id);
    };

    handleOnClassEdit = (classroomId) => {
        this.context.router.history.push(`/edit-class/${classroomId}`);
    };

    handleOnAssignTeacher = (classroomId) => {
        const assignType = 'teacherToClass';
        this.context.router.history.push(`/assign-user/${classroomId}/${assignType}`);
    };

    handleOnAssignStudent = (classId) => {
        const moduleId = window.pppAppConfig ? window.pppAppConfig.ModuleIdStudentMgmt : classEnum.FALLBACK_ID;
        const sourceModuleId = window.pppAppConfig ? window.pppAppConfig.ModuleIdSchoolRoll : classEnum.FALLBACK_ID;
        PortalCommunication.requestModuleChange({ moduleId, classId, sourceModuleId });
    };

    handleOnShowDeleteClassroomsConfirmation = () => {
        if (this.props.selectedClasses.length > 0 && this.state.rows.length > 0) {
            const selectedClassrooms = filterClassroomByIds(this.state.rows, this.props.selectedClasses);
            const isThereNonEmptyClassrooms = selectedClassrooms.some(nonEmptyClassroom);

            if (isThereNonEmptyClassrooms) {
                this.props.showToast(this.props.intl.formatMessage(messages.deletingNonEmptyClassError), 'error');
            }
            this.props.openDeleteClassroomsConfirmation(!isThereNonEmptyClassrooms);
        }
    };

    handleOnDeleteClassrooms = () => {
        this.props.deleteClassrooms(this.props.selectedClasses);
    };

    handleOnStudentSignInCards = () => {
        this.props.showHideSignInCardModalRequest(true);
    }

    handleOnCancelStudentSignInCards = () => {
        this.props.showHideSignInCardModalRequest(false);
    }

    getFilteredUPFCourses = (countryCode, productId, yearGroup) => {
        this.props.getUPFCourses(countryCode, productId, yearGroup);
    }

    getFilteredNewCourses = ({ productId }) => {
        this.props.getNewCourses(productId);
    }

    render() {
        const rowGetter = rowNumber => this.state.rows[rowNumber];
        return (
            <ClassRoll
                classesCount={this.props.classrooms.length}
                classrooms={this.state.rows}
                closeAddStudentValidationModal={this.handleOnCloseValidationModal}
                dataFilterOptions={this.state.dataFilterOption}
                displayNewCourses={this.displayNewCourses}
                filteredClassesCount={this.props.filteredClasses.length}
                filterOnChange={this.handleFilterOnChange}
                filterOnClear={this.handleFilterOnClear}
                getFilteredNewCourses={this.getFilteredNewCourses}
                getFilteredUPFCourses={this.getFilteredUPFCourses}
                gridRowGetter={rowGetter}
                handleListOnChange={this.handleListOnChange}
                handleOnAssignStudent={this.handleOnAssignStudent}
                handleOnAssignTeacher={this.handleOnAssignTeacher}
                handleOnCancelStudentSignInCards={this.handleOnCancelStudentSignInCards}
                handleOnClassEdit={this.handleOnClassEdit}
                handleOnCloseDeleteClassroomsConfirmation={this.props.closeDeleteClassroomsConfirmation}
                handleOnCloseDeleteClassroomsSuccess={this.props.closeDeleteClassroomsSuccess}
                handleOnDeleteClassrooms={this.handleOnDeleteClassrooms}
                handleOnDownloadStudentsSignInCards={this.handleOnDownloadStudentsSignInCards}
                handleOnShowDeleteClassroomsConfirmation={this.handleOnShowDeleteClassroomsConfirmation}
                handleOnStudentSignInCards={this.handleOnStudentSignInCards}
                onAddClassCloseModal={this.handleOnCloseModal}
                onDownloadClassRoll={this.handleOnDownloadClassRoll}
                onGridSort={this.handleGridSort}
                onQuickUpload={this.handleOnQuickUpload}
                onRowSelect={this.handleRowSelect}
                onSearch={this.handleOnSearch}
                yearGroups={this.props.dataFilterOption.yearGroups}
                {...this.props}
            />
        );
    }
}

function mapStateToProps(state = {}) {
    return {
        ...state,
        selectedProduct: state.product,
        classrooms: state.classRoll.classrooms,
        classModel: state.classRoll.classModel,
        dataFilterOption: state.classRoll.dataFilterOption,
        isClassroomDataLoaded: state.classRoll.isClassroomDataLoaded,
        isClassRollDownloaded: state.classRoll.isClassRollDownloaded,
        showAddClassModal: state.classRoll.showAddClassModal,
        showAddClassConfirmationModal: state.classRoll.showAddClassConfirmationModal,
        yearGroups: state.schoolRoll.yearGroups,
        productCountries: state.schoolRoll.countries.filtered,
        productTeachers: state.teacherRoll.teachersFiltered,
        productCourses: state.classRoll.productCourses,
        isCountriesLoaded: state.schoolRoll.isCountriesLoaded,
        isProductCoursesFetching: state.classRoll.isProductCoursesFetching,
        isSchoolCoursesFetching: state.classRoll.isSchoolCoursesFetching,
        isTeacherDataLoaded: state.teacherRoll.isTeacherDataLoaded,
        isYearGroupDataLoaded: state.schoolRoll.isYearGroupDataLoaded,
        selectedClasses: state.classRoll.selectedClasses,
        filteredClasses: state.classRoll.filteredClasses,
        isStudentsSignInCardDownloaded: state.classRoll.isStudentsSignInCardDownloaded,
        isProductCoursesLoaded: state.classRoll.isProductCoursesLoaded,
        isSaveInProgress: state.classRoll.isSaveInProgress,
        showAddClassValidationModal: state.classRoll.showAddClassValidationModal,
        addClassValidationMessage: state.classRoll.addClassValidationMessage,
        refreshList: state.classRoll.refreshList,
        changeCourse: state.classRoll.changeCourse,
        deletingClassrooms: state.classRoll.deletingClassrooms,
        showDeleteClassroomsConfirmation: state.classRoll.showDeleteClassroomsConfirmation,
        showDeleteClassroomsSuccess: state.classRoll.showDeleteClassroomsSuccess,
        deletingEmptyClassrooms: state.classRoll.deletingEmptyClassrooms,
        showHideSignInCardModal: state.classRoll.showHideSignInCardModal,
        upfCourses: state.classRoll.upfCourses,
        newCourses: state.classRoll.newCourses,
        classAdded: state.classRoll.classAdded,
        deletedClassesCount: state.classRoll.deletedClassesCount,
        isUPFCoursesFetching: state.classRoll.isUPFCoursesFetching,
        isNewCoursesFetching: state.classRoll.isNewCoursesFetching
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        printStudentsSignInCard,
        clearFilterValue,
        changeFilterValue,
        updateSearchTerm,
        sortClassList,
        retrieveSelectedClasses,
        openAddClassModal,
        closeAddClassModal,
        getCourseCountries,
        getProductTeachers,
        getProductCourses,
        getProductClassrooms,
        getSchoolCourses,
        addClass,
        downloadClassRoll,
        closeAddClassValidationModal,
        getStudentByClassroomIdRequest,
        deleteClassrooms,
        openDeleteClassroomsConfirmation,
        closeDeleteClassroomsConfirmation,
        openDeleteClassroomsSuccess,
        closeDeleteClassroomsSuccess,
        showToast,
        showHideSignInCardModalRequest,
        getUPFCourses,
        getNewCourses,
        clearProductCourses,
        clearUPFCourses
    }, dispatch);
}

const ContainerWithIntl = injectIntl(ClassRollContainer);
export default connect(mapStateToProps, mapDispatchToProps)(ContainerWithIntl);



// WEBPACK FOOTER //
// ./app/containers/class-roll/index.js